import { ReactElement, ReactNode } from "react";
import { ScrollSyncPane } from "react-scroll-sync";
import ActionsColumn from "./ActionsColumn";
import { operationLeftPanelWidth } from "../constants";

export default function RowLayout({
  left,
  right,
  actions,
  className = "",
  showScrollbar = false,
}: {
  left: ReactElement;
  right: ReactElement;
  actions?: ReactNode;
  className?: string;
  showScrollbar?: boolean;
}) {
  return (
    <div className={`w-full py-1 flex items-center bg-slate-100 ${className}`}>
      <div
        style={{
          minWidth: operationLeftPanelWidth,
          maxWidth: operationLeftPanelWidth,
        }}
      >
        {left}
      </div>
      <ScrollSyncPane>
        <div
          className={`overflow-x-auto ${!showScrollbar && "scrollbar-none"} bg-white rounded-tl-sm rounded-bl-sm`}
        >
          {right}
        </div>
      </ScrollSyncPane>
      <ActionsColumn>{actions}</ActionsColumn>
    </div>
  );
}
